import { render, staticRenderFns } from "./ActiveForm.vue?vue&type=template&id=49d2995d&"
import script from "./ActiveForm.vue?vue&type=script&lang=ts&"
export * from "./ActiveForm.vue?vue&type=script&lang=ts&"
import style0 from "./ActiveForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports